import React from 'react'

const CurrentYear = ({ currentYear }) => {
  return (
    <span>{(new Date().getFullYear())}</span>
  )
}

export default CurrentYear
